import React from 'react';

import Waypoint from 'react-waypoint';
import classnames from 'classnames';

class SnapshotInSection extends React.Component {
	constructor() {
		super();
		this.state = {
			isFlashing: false,
		};

		this.flashTimeout = null;
		this.flashDelayTimeout = null;

		this.getClassNames = this.getClassNames.bind(this);
		this.flash = this.flash.bind(this);
		this.flashDelay = this.flashDelay.bind(this);
	}

	getClassNames() {
		return classnames('contents__snapshot__flash', {
			'contents__snapshot__flash--is-flashing': this.state.isFlashing,
		});
	}

	flash() {
		clearInterval(this.flashTimeout);

		this.setState({ isFlashing: true });

		this.flashTimeout = setTimeout(() => {
			this.setState({ isFlashing: false });
		}, 100);
	}

	flashDelay() {
		clearInterval(this.flashDelayTimeout);

		this.flashDelayTimeout = setTimeout(() => {
			this.flash();
		}, 600);
	}

	render() {
		const style = {
			st6: {
				fill: '#F2CC7B',
			},
			st8: {
				fill: '#5994C9',
			},
			st10: {
				fill: '#B3B3B3',
			},
			st69: {
				fill: '#64a9dd',
			},
			st96: {
				fill: '#F2F2F2',
			},
			st97: {
				fill: '#CCCCCC',
			},
			st98: {
				fill: '#E6E6E6',
			},
			st99: {
				fill: '#FFF1B8',
			},
		};

		return (
			<div className="contents__snapshot--wrapper">
				<div className="contents__snapshot" onMouseDown={this.flash}>
					<img src="extension-assets/frame.png" alt="" />
					<svg version="1.1" viewBox="0 0 113.2 89.9">
						<path style={style.st10} d="M106.6,50.6v25.6c0,4.6-3.8,8.4-8.4,8.4H15c-4.6,0-8.4-3.8-8.4-8.4V50.6H106.6z" />
						<path style={style.st96} d="M6.6,50.6V25.3c0-4.6,3.8-8.4,8.4-8.4h83.2c4.6,0,8.4,3.8,8.4,8.4v25.3H6.6z" />
						<path style={style.st10} d="M73.9,50.6C73.9,65.7,61.7,78,46.6,78S19.3,65.7,19.3,50.6H73.9z" />
						<path style={style.st97} d="M19.3,50.6c0-15.1,12.2-27.3,27.3-27.3s27.3,12.2,27.3,27.3H19.3z" />
						<circle style={style.st96} cx="46.6" cy="50.6" r="21.9" />
						<path style={style.st98} d="M89.4,39.5L89.4,39.5c-4.1,0-7.5-3.4-7.5-7.5v0c0-4.1,3.4-7.5,7.5-7.5h0c4.1,0,7.5,3.4,7.5,7.5v0
							C96.9,36.1,93.6,39.5,89.4,39.5z" />
						<path style={style.st96} d="M77.9,19.9L66.5,7c-1-1.1-2.4-1.8-3.9-1.8H46.8H31c-1.5,0-2.9,0.6-3.9,1.8L15.6,19.9H77.9z" />
						<circle style={style.st8} cx="46.6" cy="50.6" r="16" />
						<path style={style.st69} d="M38,50.6c-1.2,0-2-1.1-1.8-2.3c1-4.8,5.3-8.4,10.4-8.4c5.1,0,9.4,3.6,10.4,8.5c0.2,1.1-0.7,2.1-1.8,2.1H38z"
							/>
						<path style={style.st98} d="M52,10.1H41.2c-2.5,0-4.5,2-4.5,4.5v0c0,2.5,2,4.5,4.5,4.5H52c2.5,0,4.5-2,4.5-4.5v0
							C56.5,12.1,54.5,10.1,52,10.1z" />
					</svg>
					<svg className={this.getClassNames()} version="1.1" viewBox="0 0 113.2 89.9">
						<polygon style={style.st6} points="83.7,18.7 95,9.2 99.8,23.1 112.4,30.9 100.6,39.8 97.2,54.1 85,45.7 70.3,46.8 74.6,32.7 69,19
							" />
						<polygon style={style.st99} points="87.2,38.1 80.6,38.6 82.5,32.3 80,26.2 86.6,26 91.6,21.8 93.8,28 99.4,31.5 94.2,35.5 92.6,41.9
							" />
					</svg>
					<Waypoint onEnter={this.flashDelay} />
				</div>
			</div>
		);
	}
}

export default SnapshotInSection;



// WEBPACK FOOTER //
// ./src/components/Site/Home/SnapshotInSection.js